export default "__VITE_ASSET__CeXo$5GZ__"